import * as React from 'react';
import * as style from './Questions.css';
import { IQuestion } from '../../types/helper';
import { QUESTIONS } from '../../constants/page-content';
import { mergeStyles } from '@cian/utils';
import { IconArrow } from './icon/arrow';
import { NoAnswerQuestionItem } from './items/no-answer';

interface IQuestionsState {
  openedQuestionIndex: number | null;
}

export class Questions extends React.Component<{}, IQuestionsState> {
  public state = {
    openedQuestionIndex: 0,
  }

  private handleOnClick = (index: number) => () => {
    this.setState({
      openedQuestionIndex: index === this.state.openedQuestionIndex ? null : index,
    })
  }

  public render() {
    const { openedQuestionIndex } = this.state;

    return <div className={style['question_container']}>
      <div className={style['question_head']}>Вопросы</div>
      {QUESTIONS.map((question, index) => (
        <Question
          key={`q${index}`}
          question={question}
          expanded={index === openedQuestionIndex}
          onClick={this.handleOnClick(index)}
        />
      ))}
    </div>;
  }
}

interface IQuestionProps {
  question: IQuestion;
  expanded: boolean;
  onClick(): void;
}

const Question = (props: IQuestionProps) => (
  <div className={style['question_row']} onClick={props.onClick}>
    <div className={style['question_title']}>
      {props.question.title}
      <div className={style['question_arrow']}>
        <IconArrow type={props.expanded ? 'up' : 'down'}/>
      </div>
    </div>
    <div {...mergeStyles([
      style['question_body'],
      props.expanded && style['opened'],
    ])}>
      {props.question.component === 'no-answer'
        ? <NoAnswerQuestionItem />
        : props.question.body
      }
    </div>
  </div>
);
